<template>
    <div>
        <Breadcrumb></Breadcrumb>
        <el-row>
            平台渠道：
            <el-select clearable  v-model="systemValue" placeholder="请选择" size="small" @change="loadTableData">
                <el-option
                        v-for="item in systemOption"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictValue">
                </el-option>
            </el-select>
        </el-row>
        <el-row style="margin-top: 20px">
            <a style="float: left">所属类目：</a>
            <div v-for="(item, index) in tableDataList" @mouseover="changeTableIndex(index)" style="display: inline-block; float: left; margin-left: 4px">
                <el-table
                        :ref="'treeTable' + index"
                        height="300"
                        border
                        @row-click="rowClick"
                        highlight-current-row
                        :data="item.filter(data => !searchValue[index] || data.platName.toLowerCase().includes(searchValue[index].toLowerCase()))"
                        style="width: 201px">
                    <el-table-column
                            prop="platName"
                            align="center"
                            width="200">
                        <template slot="header" slot-scope="scope">
                            <el-input
                                    v-model="searchValue[index]"
                                    size="small"
                                    placeholder="输入关键字搜索">
                                <template slot="append"><el-button slot="append" icon="el-icon-search" size="mini"></el-button></template>
                            </el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="clear: both"></div>
            <div style="margin-top: 10px; margin-bottom: 10px">{{ baseAttrValuePath }}</div>
            <vxe-table
                    border
                    resizable
                    show-overflow
                    :data="forms"
                    :edit-config="{trigger: 'click', mode: 'row'}"
                    v-if="baseAttrValuePath != ''">
                <vxe-table-column field="attrId" title="属性名ID" :edit-render="{name: 'input', attrs: {type: 'text'}}"></vxe-table-column>
                <vxe-table-column field="attrName" title="属性名" :edit-render="{name: 'input', attrs: {type: 'text'}}"></vxe-table-column>
                <vxe-table-column field="sortNo" title="排序" :edit-render="{name: 'input', attrs: {type: 'text'}}"></vxe-table-column>
                <vxe-table-column field="value" title="属性值" :edit-render="{name: 'input', attrs: {type: 'text'}}"></vxe-table-column>
                <vxe-table-column field="isEffect" title="是否启用" :edit-render="{name: '$select', options: isOption}"></vxe-table-column>
                <vxe-table-column title="操作" width="100" show-overflow>
                    <template v-slot="{ row }">
                        <vxe-button type="text" icon="fa fa-trash-o" @click="deleteForm(row)"></vxe-button>
                    </template>
                </vxe-table-column>
            </vxe-table>
            <div style="text-align: right; margin-top: 10px" v-if="isAdd">
                <el-button type="primary" @click="addAttr">新增属性</el-button>
                <el-button type="primary" @click="saveAttr">保存/提交</el-button>
            </div>
        </el-row>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {listPlatType} from '@/api/plat/platType'
    import request from '@/utils/request'
    export default {
        name: "variAttr",
        components:{ Breadcrumb
        },
        data() {
            return {
                isAdd: false,
                forms: [],
                baseAttrValuePath: "",
                systemValue: "",
                systemOption: [],
                searchValue: [],
                tableData: [],
                tableDataList: [],
                clickTableIndex: 0,
                currentTableIndex: 0,
                treeIndex: [],
                isOption: [{
                    value: '01',
                    label: '是'
                }, {
                    value: '02',
                    label: '否'
                }]
            }
        },
        created() {
            this.getDicts("s_plat_code").then(response => {
                this.systemOption = response.data;
                this.systemValue = response.data[0].dictValue;
                this.loadTableData();
            });
        },
        watch: {
            tableDataList(value){
                let list = [];
                value.forEach((item, index) => {
                    list[index] = this.searchValue[index];
                });
                this.searchValue = list;
            }
        },
        methods: {
            saveAttr(){
                let that = this;
                this.forms.forEach(item => {
                    item.platNo = this.systemValue;
                    item.catId = this.tableDataList[this.tableDataList.length - 1][this.treeIndex[this.treeIndex.length - 1]].platId;

                    item.sAttrValList = [];
                    try {
                        item.value.split(",").forEach((value, index) => {
                            let valName = value.substr(0, value.indexOf(":"));
                            let engValName = value.substr(value.indexOf(":") + 1, value.length);
                            item.sAttrValList.push({
                                valName: valName,
                                engValName: engValName,
                                attrId: item.attrId,
                                sortNo: index + 1
                            });
                        });
                    }catch (e) {
                        item.sAttrValList = [];
                    }
                });
                request({
                    url: '/platform/attr',
                    method: 'post',
                    data: this.forms
                }).then((data) => {
                    if(data.code == 200){
                        that.$message({
                            type: 'success',
                            message: data.msg
                        });
                    }else{
                        that.$message.error(data.msg);
                    }
                    that.loadForms();
                })
            },
            addAttr(){
                this.forms.push({
                    attrId: new Date().getTime() + "" + Math.floor(Math.random() * 10),
                    attrName: "",
                    value: "",
                    sortNo: "",
                    isEffect: "01"
                });
            },
            loadTableData(){
                listPlatType({
                    platNo: this.systemValue
                }).then(response => {
                    this.tableData = this.handleTree(response.data, "platId",'pPlatId');
                    this.tableDataList = [this.tableData];
                    this.forms = [];
                });
            },
            deleteForm(item){
                let that = this;
                that.$confirm('确认要删除该属性？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/platform/attr/' + item.id,
                        method: 'delete'
                    }).then((data) => {
                        that.$message({
                            type: 'success',
                            message: data.msg
                        });
                        that.loadForms();
                    });
                });
            },
            changeTableIndex(index){
                this.currentTableIndex = index;
            },
            rowClick(row){
                for(let i = 0; i < this.treeIndex.length; i ++){
                    if(i > this.currentTableIndex){
                        this.treeIndex[i] = 0;
                    }
                }
                let clickIndex = this.tableDataList[this.currentTableIndex].findIndex(item => row.platName == item.platName);
                this.treeIndex[this.currentTableIndex] = clickIndex;
                for(let i = 0; i < this.tableDataList.length; i ++){
                    if(i > this.currentTableIndex){
                        this.tableDataList.splice(i, 1);
                    }
                }
                if(this.tableDataList[this.currentTableIndex][clickIndex].children != undefined
                    && this.tableDataList[this.currentTableIndex][clickIndex].children != null
                    && this.tableDataList[this.currentTableIndex][clickIndex].children.length > 0){
                    this.tableDataList.splice(this.currentTableIndex + 1, 1, this.tableDataList[this.currentTableIndex][clickIndex].children);
                }
                if(row.isLeaf == "1"){
                    this.isAdd = true;
                    this.loadForms();
                    this.setBaseAttrValuePath();
                }else{
                    this.isAdd = false;
                    this.forms = [];
                    this.baseAttrValuePath = "";
                }
            },
            loadForms(){
                let that = this;
                that.forms = [];
                request({
                    url: '/platform/attr/list',
                    method: 'get',
                    params: {
                        catId: that.tableDataList[that.tableDataList.length - 1][that.treeIndex[that.treeIndex.length - 1]].platId
                    }
                }).then((response) => {
                    response.rows.forEach((form, index) => {
                        form.value = "";
                        form.sAttrValList.forEach(value => {
                            form.value += value.valName + ":" + value.engValName + ",";
                        });
                        form.value = form.value.substr(0, form.value.length - 1);
                    });
                    that.forms = response.rows;
                })
            },
            setBaseAttrValuePath(){
                this.$nextTick(() => {
                    this.baseAttrValuePath = "";
                    this.tableDataList.forEach((item, index) => {
                        this.baseAttrValuePath += item[this.treeIndex[index]].platName + "(" + item[this.treeIndex[index]].engPlatName + ") > ";
                    });
                    this.baseAttrValuePath = this.baseAttrValuePath.substring(0, this.baseAttrValuePath.length - 3);
                });
            }
        }
    }
</script>

<style scoped>
</style>
